import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useHeaderFooter } from '../../hooks';

import './index.scss';
import messages from './messages';

import privacyPolicyBackgroundImg from '../../img/privacyPolicy/privacy-policy_.jpg';

const PrivacyPolicy = ({ children }: { children: React.ReactNode }) => {
  const { headerContent, footerContent } = useHeaderFooter(children);
  const intl = useIntl();

  const emailLink = (chunks: React.ReactNode) => <a href={`mailto:${chunks}`}>{chunks}</a>;
  const phoneLink = (chunks: React.ReactNode) => <a href={`tel:${chunks}`}>{chunks}</a>;

  return (
    <>
      <input type="hidden" id="anPageName" name="page" defaultValue="about" />
      <div className="container-center-horizontal">
        <div className="about screen contact">
          <div className="homepage ">
            {headerContent}
            <div className="overlap-group6">
              <div className="hero-image">
                <div className="overlap-group-1">
                  <div
                    className="overlap-group-item"
                    style={{
                      backgroundImage: `url("${privacyPolicyBackgroundImg}")`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      backgroundBlendMode: 'overlay',
                      width: '100%',
                      height: '100%',
                    }}
                    role="img"
                    aria-label={intl.formatMessage(messages.privacyPolicyBackgroundAlt)}
                  />
                  <h1 className="about-us recklessneue-regular-normal-white-100-1px">
                    <span className="recklessneue-regular-normal-white-100-1px">
                      {intl.formatMessage(messages.privacyPolicy)}{' '}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="course-overview-text">
            <div className="overlap-group5 pres-overlap">
              <p className="lorem-ipsum-dolor-si-1 neuehaasgroteskdisplaypro-45-light-congress-blue-24px pres-desc">
                {intl.formatMessage(messages.intro)}
              </p>
            </div>
          </div>
          <div className="legatum-container the-course">
            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.whatDataTitle)}</div>
              <div className="leg-p">
                {intl.formatMessage(messages.whatDataDescription)}
                <ul style={{ margin: '5px' }}>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.basicInfo)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.contactInfo)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.financialInfo)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.technicalInfo)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.courseResponses)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.otherInfo)}</li>
                </ul>
              </div>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.howCollectTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.howCollectDesc1)}
              </p>
              <p className="leg-p">
                {intl.formatMessage(messages.howCollectDesc2)}
              </p>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.dataUsageTitle)}</div>
              <div className="leg-p">
                {intl.formatMessage(messages.dataUsageDescription)}
                <ul style={{ margin: '5px' }}>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.useProvideImproveSite)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.useProvideImproveServices)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.useProvideInfo)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.useDevelopContent)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.usePromote)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.useManageRelationship)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.useResearchPartners)}</li>
                </ul>
              </div>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.whereProcessTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.whereProcessDescription)}
              </p>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.protectingTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.protectingDescription)}
              </p>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.rightsTitle)}</div>
              <div className="leg-p">
                {intl.formatMessage(messages.rightsDescription)}
                <ul style={{ margin: '5px' }}>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.rightAccess)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.rightRectification)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.rightErasure)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.rightRestrict)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.rightObject)}</li>
                  <li style={{ margin: '5px' }}>{intl.formatMessage(messages.rightPortability)}</li>
                </ul>
              </div>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.retentionTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.retentionDescription)}
              </p>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.otherWebsitesTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.otherWebsitesDescription)}
              </p>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.changesTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.changesDescription)}
              </p>
            </div>

            <div className="c-section">
              <div className="leg-title">{intl.formatMessage(messages.contactTitle)}</div>
              <p className="leg-p">
                {intl.formatMessage(messages.contactDesciption)}
                <br />
                {intl.formatMessage(messages.contactEmail, {
                  link: emailLink,
                })}
                <br />
                {intl.formatMessage(messages.contactPhone, {
                  link: phoneLink,
                })}
                <br />
                {intl.formatMessage(messages.contactAddressLabel)}
              </p>
            </div>
          </div>
          {footerContent}
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
